<template>
  <div class="container">
    <!-- 保修列表 -->
    <div class="scroll-y">
      <div
        class="plbm-list"
        v-for="(item,index) in inspectionList "
        :key="index"
        @click="handleGopageDetails(item.id)"
      >
        <div class="plbm-list-type">巡检人：{{item.userName}}</div>
        <div class="plbm-list-type">巡检时间：{{item.inspectionDate}}</div>
        <div class="plbm-list-type">网吧：{{item.siteName}}</div>
      </div>
    </div>
    <!-- 保修按钮 -->
    <div class="plbm-btn" @click="handleGopageWrite">填写巡检单</div>
  </div>
</template>
<script>
import { inspectionList } from "@/api/inspection";
export default {
  data() {
    return {
      inspectionList: []
    };
  },
  mounted() {
    this.requestInspectionList();
  },
  methods: {
    // 请求巡检列表
    requestInspectionList() {
      inspectionList().then(res => {
        console.log(res);
        this.inspectionList = res.data;
      });
    },
    // 填写巡检单
    handleGopageWrite() {
      this.$router.push({
        path: "/writeinspectionrecords"
      });
    },
    // 详情
    handleGopageDetails(id) {
      this.$router.push({
        path: "/inspectionrecordsdetails",
        query: {
          id: id
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
// $percentage
// 状态颜色处理
.red-color {
  color: #ff3838;
}
.gray-color {
  color: #999999;
}
.yellow-color {
  color: #ffaa00;
}
.blue-color {
  color: #008cff;
}
.container {
  width: 100%;
  height: 100%;
  background-color: #f6f6f6;
  overflow-x: hidden;
  &::-webkit-scrollbar {
    display: none;
  }
  .scroll-y {
    width: 100%;
    height: 89%;
    background-color: #f6f6f6;
    overflow-x: hidden;
    &::-webkit-scrollbar {
      display: none;
    }
  }
  // 列表内容
  .plbm-list {
    width: 350px;
    height: 110px;
    background-color: $white-color;
    margin: 10px 13px;
    border-radius: 8px;
    font-size: 14px;
    text-align: left;
    .plbm-list-type {
      padding: 10px 15px;
      box-sizing: border-box;
    }
  }
  // 按钮
  .plbm-btn {
    width: 350px;
    height: 44px;
    background: -webkit-linear-gradient(left, #05aefc, #008cff);
    margin: 0 auto;
    border-radius: 22px;
    font-size: 16px;
    color: $white-color;
    line-height: 44px;
    position: fixed;
    bottom: 20px;
    left: 50%;
    margin-left: -175px;
  }
}
</style>